import React from "react";

export default function Logo({ size = 34, showText = true }) {
  return (
    <div className="flex items-center gap-3">
      <svg
        width={size}
        height={size}
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="avGrad" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#f5d572" />
            <stop offset="0.5" stopColor="#d4af37" />
            <stop offset="1" stopColor="#a67bff" />
          </linearGradient>
        </defs>
        <circle cx="22" cy="22" r="20" stroke="url(#avGrad)" strokeWidth="1" opacity="0.55" />
        {Array.from({ length: 12 }).map((_, i) => {
          const a = (i * Math.PI * 2) / 12;
          const x1 = 22 + Math.cos(a) * 12;
          const y1 = 22 + Math.sin(a) * 12;
          const x2 = 22 + Math.cos(a) * 16;
          const y2 = 22 + Math.sin(a) * 16;
          return (
            <line
              key={i}
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              stroke="url(#avGrad)"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
          );
        })}
        <circle cx="22" cy="22" r="8" fill="url(#avGrad)" opacity="0.9" />
        <path d="M28 18 Q22 22 28 26 Q26 22 28 18Z" fill="#06040c" />
        <path d="M32 6 L33 9 L36 10 L33 11 L32 14 L31 11 L28 10 L31 9 Z" fill="url(#avGrad)" />
      </svg>
      {showText && (
        <div className="leading-tight">
          <span
            className="font-display block text-[15px] tracking-[0.14em]"
            style={{ color: "var(--star)" }}
          >
            LE CHAT
          </span>
          <span
            className="font-display block text-[15px] tracking-[0.14em]"
            style={{ color: "var(--gold)" }}
          >
            GRÉCO-CELTIQUE
          </span>
          <span className="block text-[8px] font-mono tracking-[0.28em] uppercase mt-0.5" style={{ color: "var(--muted)" }}>
            Oracles · Bardes · Sagesse
          </span>
        </div>
      )}
    </div>
  );
}
